module.exports = __webpack_public_path__ + "img/order_restaurant_windows.9505666c.png";